/**************************************************
 * Nombre:       Seccion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Certfiicados from "./Componentes/Home_Certfiicados";
import Home_Caracteristicas from "./Componentes/Home_Caracteristicas";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Home_Contactos from "./Componentes/Home_Contactos";
import Detalle_Producto from "./Componentes/Detalle_Producto";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Detalle = () => {

    useEffect(() =>{

        irArriba()

    },[])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#202020', mt: -16}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 18}}>
                <Detalle_Producto/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 24}}>
                <Home_Certfiicados/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                <Home_Caracteristicas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Testimonios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Contactos/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Detalle    